import { render, staticRenderFns } from "./PaperForm.vue?vue&type=template&id=c9e407f8"
import script from "./PaperForm.vue?vue&type=script&lang=js"
export * from "./PaperForm.vue?vue&type=script&lang=js"
import style0 from "./PaperForm.vue?vue&type=style&index=0&id=c9e407f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports